import LanguageRoundedIcon from '@mui/icons-material/LanguageRounded';
import Box from '@mui/material/Box';
import is from '@sindresorhus/is';
import { useContext } from 'react';

import { LanguageList } from './LanguageList';
import { ApplicationContext } from '../../../../../../../shared/source/context/context';
import { ContentHeadline, ContentWrapper } from '../../../../../design/components/containers/ContentWrapper';
import { InlineLoadingSpinner } from '../../../../../design/components/LoadingSpinner';
import { useScrollToLocationHash } from '../../../../use-scroll-to-location-hash';
import { CardPlaceholder } from '../common/CardPlaceholder';

import type { LanguageSkill } from '../../../../../../../shared/source/data-contract/skill';
import type { FunctionComponent, ReactNode } from 'react';

type LanguageContentProps = {
    readonly action?: ReactNode | undefined;
    readonly isFetching?: boolean | undefined;
    readonly languageSkills: readonly LanguageSkill[] | undefined;
};

export const LanguageContent: FunctionComponent<LanguageContentProps> = ({ action, isFetching, languageSkills }) => {
    const { translate } = useContext(ApplicationContext);

    useScrollToLocationHash();

    return (
        <ContentWrapper>
            <Box
                className="language-content"
                id="languages"
                sx={{
                    position: 'relative',
                    top: -75,
                }}
            />
            <ContentHeadline actions={action} text={translate('pages.recruiter-profile.languages.title')} />
            {isFetching === true ? (
                <InlineLoadingSpinner />
            ) : is.array(languageSkills) && is.nonEmptyArray(languageSkills) ? (
                <LanguageList languageList={languageSkills} />
            ) : (
                <CardPlaceholder
                    placeholderIcon={<LanguageRoundedIcon />}
                    placeholderText={translate('pages.recruiter-profile.languages.placeholder')}
                />
            )}
        </ContentWrapper>
    );
};
